import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { RegionSelector } from '../../components/Filters';
import { EGeoName } from '../../types/share';
import { updateCharts } from '../../actions/filters';

import { trackRegionFilterChange } from './tracking';
import { REGIONS_OPTIONS } from '../../constants/filters';
import { getRegion } from '../../selectors';

export function RegionSelectorContainer() {
  const region = useSelector(getRegion);
  const dispatch = useDispatch();

  const onChange = React.useCallback(
    (value: EGeoName) => {
      if (value === region) {
        return;
      }

      dispatch(updateCharts('region', value));
      trackRegionFilterChange(value);
    },
    [dispatch, region],
  );

  return <RegionSelector region={region} values={REGIONS_OPTIONS} onChange={onChange} />;
}
